/* Kidslar native PDP kit — gallery + add-to-cart.
   ATC deliberately avoids a native form submit: Conversios rewrites the form action
   (/cart/add?attributes[...]), so we click-capture, keep those attributes, POST /cart/add.js
   and hand the response to cart-drawer.renderContents (which also triggers the upsell pop-up). */
(function () {
  if (window.__kpInit) return;
  window.__kpInit = true;

  function initGallery(root) {
    var track = root.querySelector('.kp-gallery__track');
    if (!track) return;
    var marks = root.querySelectorAll('[data-kp-slide-to]');
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var i = current();
      marks.forEach(function (m) { m.setAttribute('aria-current', String(+m.dataset.kpSlideTo === i)); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    marks.forEach(function (m) {
      m.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * +m.dataset.kpSlideTo, behavior: 'smooth' });
      });
    });
    mark();
  }

  function addToCart(btn) {
    var form = document.getElementById(btn.dataset.kpForm);
    if (!form || btn.getAttribute('aria-busy') === 'true') return;
    var fd = new FormData(form);
    // Bundle snippet (kidslar-bundle) writes the chosen quantity into the form; default 1.
    if (!fd.get('quantity')) fd.set('quantity', '1');
    var act = form.getAttribute('action') || '', qi = act.indexOf('?');
    if (qi > -1) new URLSearchParams(act.slice(qi + 1)).forEach(function (v, k) { if (!fd.has(k)) fd.append(k, v); });
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id || s.section; }).filter(Boolean).join(',')
      : 'cart-drawer,cart-icon-bubble';
    fd.append('sections', sections);
    fd.append('sections_url', location.pathname);
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) { alert(data.description || data.message || 'Sepete eklenemedi'); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }

  // Mobile/desktop twins share an id; always pick the one that is actually shown.
  function visibleById(id) {
    var all = document.querySelectorAll('[id="' + id + '"]');
    for (var i = 0; i < all.length; i++) if (all[i].getClientRects().length) return all[i];
    return all[0] || null;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#kp-"]');
    if (a) { var tg = visibleById(a.getAttribute('href').slice(1)); if (tg) { e.preventDefault(); tg.scrollIntoView({ behavior: 'smooth', block: 'start' }); } return; }
    var pop = e.target.closest('[data-kp-popup]');
    if (pop) { e.preventDefault(); var d = document.getElementById(pop.dataset.kpPopup); if (d && d.showModal) d.showModal(); return; }
    if (e.target.closest('[data-kp-close]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG') { e.target.close(); return; }
    var btn = e.target.closest('[data-kp-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.kpAtc === 'scroll') {
      var t = btn.dataset.kpTarget === 'top' || !btn.dataset.kpTarget ? document.querySelector('.kp-main') : visibleById(btn.dataset.kpTarget);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: btn.dataset.kpTarget === 'top' ? 'start' : 'center' });
      return;
    }
    addToCart(btn);
  });

  document.addEventListener('click', function (e) {
    var st = e.target.closest('[data-kp-step]');
    if (!st) return;
    var box = st.closest('.kp-qty'), inp = box.querySelector('input');
    inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+st.dataset.kpStep));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var box = e.target.closest('.kp-qty');
    if (!box) return;
    var v = Math.max(1, parseInt(e.target.value, 10) || 1); e.target.value = v;
    var form = document.getElementById(box.dataset.kpQtyForm), q = form && form.querySelector('[name="quantity"]');
    if (q) q.value = v;
  });

  // Videos carry preload="none" + data-kp-autoplay: nothing downloads until one nears the viewport
  // (hidden mobile/desktop twins never intersect, so they never download).
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '300px 0px' }) : null;
  function initVideos() {
    document.querySelectorAll('video[data-kp-autoplay]:not([data-kp-v])').forEach(function (v) {
      v.setAttribute('data-kp-v', '');
      if (vio) vio.observe(v); else { v.preload = 'auto'; v.play(); }
    });
  }

  // Reviews (k-pdp-reviews, mode native). First 12 cards are server-rendered; search/sort/"load more"
  // re-render from the embedded JSON. Cards flow round-robin into columns (same order as Ali's masonry).
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"%C><path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6L10 15l-5.4 3 1.2-6L1.3 7.8l6.1-.7z"/></svg>';
  var VER = '<svg viewBox="0 0 10 11" aria-hidden="true"><circle cx="5" cy="5.5" r="5" fill="currentColor"/><path d="M2.9 5.6l1.4 1.4 2.8-2.9" fill="none" stroke="#fff" stroke-width=".9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function stars(n) { var h = ''; for (var i = 1; i <= 5; i++) h += STAR.replace('%C', i <= n ? ' class="on"' : ''); return '<span class="kp-rv__stars" role="img" aria-label="' + n + '/5">' + h + '</span>'; }
  function card(r) {
    var src = r.i && r.i[0] ? r.i[0].split('?')[0] : '';
    return '<article class="kp-rv__card" data-s="' + r.s + '" data-ts="' + r.ts + '" data-img="' + (src ? 1 : 0) + '">' +
      (src ? '<button type="button" class="kp-rv__img" data-kp-rv-open><img src="' + src + '?width=540" srcset="' + src + '?width=300 300w, ' + src + '?width=540 540w" sizes="(min-width: 990px) 270px, 100vw" alt="' + esc(r.a) + ' yorum fotoğrafı" loading="lazy"></button>' : '') +
      '<div class="kp-rv__body"><div class="kp-rv__author">' + esc(r.a) + '</div><div class="kp-rv__meta"><span>' + esc(r.d) + '</span>' + (r.c === 'TR' ? '<i class="kp-rv__flag" title="Türkiye"></i>' : '') + '</div>' +
      '<div class="kp-rv__score">' + (r.v ? '<span class="kp-rv__ver">' + VER + 'Doğrulanmış Satın Alma</span>' : '<span>Puanlama: ' + r.s + '/5</span>') + stars(r.s) + '</div><p class="kp-rv__text">' + esc(r.t) + '</p>' +
      '<button type="button" class="kp-rv__readmore" data-kp-rv-open hidden>Daha Fazla Gör</button></div></article>';
  }
  function initReviews(root) {
    if (root.__kp) return; root.__kp = true;
    var list = root.querySelector('[data-kp-rv-list]'), more = root.querySelector('[data-kp-rv-more]');
    var empty = root.querySelector('[data-kp-rv-empty]'), q = root.querySelector('[data-kp-rv-q]'), sort = root.querySelector('[data-kp-rv-sort]');
    var all = []; try { all = JSON.parse(root.querySelector('[data-kp-rv-data]').textContent); } catch (e) {}
    all.forEach(function (r, i) { r.o = i; });  // Ali order (pinned first) = default 'date' order
    var step = +root.dataset.kpRvPage || 12, shown = step, view = all, cards = [].slice.call(list.children), cols = 0;
    function ncols() { return window.innerWidth >= 990 ? 4 : window.innerWidth >= 750 ? 2 : 1; }
    function layout(force) {
      var n = ncols(); if (!force && n === cols) return; cols = n;
      list.innerHTML = ''; list.classList.toggle('is-masonry', n > 1);
      if (n === 1) cards.forEach(function (c) { list.appendChild(c); });
      else {
        var cs = []; for (var i = 0; i < n; i++) { var d = document.createElement('div'); d.className = 'kp-rv__col'; list.appendChild(d); cs.push(d); }
        cards.forEach(function (c, i) { cs[i % n].appendChild(c); });
      }
      cards.forEach(function (c) { var t = c.querySelector('.kp-rv__text'), b = c.querySelector('.kp-rv__readmore'); if (b && !c.classList.contains('is-open')) b.hidden = t.scrollHeight <= t.clientHeight + 1; });
    }
    function render() {
      var term = (q.value || '').trim().toLocaleLowerCase('tr');
      view = all.filter(function (r) { return !term || (r.t + ' ' + r.a).toLocaleLowerCase('tr').indexOf(term) > -1; });
      var k = sort.value;
      view = view.slice().sort(function (a, b) {
        if (k === 'high' && a.s !== b.s) return b.s - a.s;
        if (k === 'low' && a.s !== b.s) return a.s - b.s;
        if (k === 'photo' && (a.i.length > 0) !== (b.i.length > 0)) return b.i.length - a.i.length;
        return a.o - b.o;
      });
      var tmp = document.createElement('div'); tmp.innerHTML = view.slice(0, shown).map(card).join('');
      cards = [].slice.call(tmp.children);
      empty.hidden = view.length > 0; if (more) more.parentNode.hidden = shown >= view.length;
      layout(true);
    }
    var tq; q.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(function () { shown = step; render(); }, 200); });
    sort.addEventListener('change', function () { shown = step; render(); });
    if (more) more.addEventListener('click', function () { shown += step; render(); });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('[data-kp-rv-open]'); if (!o) return;
      var c = o.closest('.kp-rv__card');
      if (o.classList.contains('kp-rv__readmore')) { c.classList.add('is-open'); o.hidden = true; return; }
      var box = root.querySelector('[data-kp-rv-lightbox]'), img = c.querySelector('img');
      box.querySelector('[data-kp-rv-lightbox-body]').innerHTML = '<img src="' + img.src.split('?')[0] + '?width=1000" alt="">' + c.querySelector('.kp-rv__body').innerHTML.replace(/<button[^>]*data-kp-rv-open[^>]*>.*?<\/button>/, '').replace('kp-rv__text', 'kp-rv__text kp-rv__text--full');
      box.querySelector('.kp-rv__text--full').style.cssText = 'display:block;-webkit-line-clamp:unset';
      box.showModal();
    });
    layout(true);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(false); }, 150); });
    // A posted review form reloads the page; reopen the dialog so the thank-you shows.
    if (/contact_posted=true/.test(location.search)) { var w = root.querySelector('.kp-rv__dialog[id]'); if (w && w.showModal) w.showModal(); }
  }

  function boot() { document.querySelectorAll('.kp-gallery').forEach(initGallery); initVideos(); document.querySelectorAll('[data-kp-rv]').forEach(initReviews); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
